import { useState,  useLayoutEffect, useEffect } from "react";
import { CreatePrimaryToken, FetchIndividual, GetSecuredContents, getInfo, CreateSecondaryToken, GetTemplatesByServiceProviderID, GetTemplateByID, GetStreams, GetStream, getLoginStatus } from "../utilities/calls";
import { useNavigate, Link, useParams,useLocation } from "react-router-dom";
import { AiOutlineImport, AiOutlineProfile } from "react-icons/ai";
import { ProcessTemplate } from "../utilities/templates";

export default function ContactSP() {
    let {  state } = useLocation();
    const { pathname } = useLocation();

    const [previousPage, setPreviousPage] = useState(state?.previousPage);
    const [individual, setIndividual] = useState({});
    const [addrList, setAddrList] = useState([]);
    const [showAlert, setShowAlert] = useState();
    const [alertText, setAlertText] = useState();
    const text = state?.text || "";
    const isBen = state?.isBen || pathname?.includes("contactBeneficiary")|| false;
    const [contenttype, setContenttype] = useState(state?.contenttype || "");
    const [securedContents, setSecuredContents] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [selectedDocId, setSelectedDocId] = useState();
    const [addressSelected, setAddressSelected] = useState();
    const [selectedContentId, setSelectedContentId] = useState();
    const { id } = useParams();
    const navigate = useNavigate();
    const [sent, setSent] = useState(true);
    const [selectedTemplate, setSelectedTemplate] = useState();

    const [templates, setTemplates] = useState([{
        Name: "Documents", Tags: {
            "DisplayName": {
                "Name": "DisplayName",
                "Value": "Documents",
                "Private": false,
                "Required": true,
                "Editable": false
            }
        }
    },{Name: "address_locales", Tags: { "DisplayName": {
        "Name": "DisplayName",
        "Value": "Addresses",
        "Private": false,
        "Required": true,
        "Editable": false
}}}]);

    useEffect(() => {
    const loginStatus = getLoginStatus();
    if (loginStatus === "LoggedOut") {
        sessionStorage.setItem('redirectto', pathname)
        navigate("/login", {
            state: { error: "You are not logged in." },
        });
    }
    },[])

    useLayoutEffect(() => {
        
        sessionStorage.setItem('redirectto', pathname)

        const individualid = getInfo("IndividualID");
        FetchIndividual(individualid)
            .then((individualData) => {
                setIndividual(individualData);
                setAddrList(individualData.addresses);
                //setSent(Object.keys(individualData.addresses).length === 1 ? false : true);
                if(Object.keys(individualData.addresses).length > 0) setAddressSelected(individualData.addresses[Object.keys(individualData.addresses)[0]]);
            })
            .catch((error) => {
                console.error("Error fetching individual:", error);
            });
        GetSecuredContents().then((resp) => {
            setSecuredContents(resp)
        }).catch(err => console.log('Error getting secured content', err))
    }, []);

    useEffect(() => {
        if(contenttype !== "" && securedContents.filter(a => a.tags?.contenttype?.Value === contenttype).length > 0) 
            setSent(false);
        if(contenttype){
            const selected = templates.find(ele =>  contenttype === ele.Name);
            if(selected) 
                setSelectedTemplate(selected);
        }
    }, [contenttype, securedContents, templates]);

    const getTemplates = (spid) => {
        
        GetTemplatesByServiceProviderID(spid).then((templateIdsArr) => {
            templateIdsArr.forEach((id) => {
                GetTemplateByID(id).then((t) => {  
                setTemplates(templates => [...templates, t]);
            }).catch(err => console.log('Err in getting template details', err))
            })
        }).catch(err => console.log('Err in getting template', err));
    }
    
    
      useEffect(() => {
        let defaultSP = getInfo('DefaultServiceProvider');
        if(defaultSP)
            getTemplates(defaultSP);
        if(!isBen && defaultSP !== id)
            getTemplates(id);
      },[id, isBen])
    
      useEffect(() => {
        GetStreams().then(resp => {
            resp.forEach((stream)=> {
                    GetStream(stream.ID)
                    .then(resp => {
                        setDocuments(prev => ([...prev,resp]));
                    })
                    .catch(err => console.log('Error getting stream details', err))
            });
        }).catch((err) => {
            console.log('Err in getting streams', err)
        })
      }, []);

    const connect = () => {
        let contentid = "", addressid = "", streamid = "";
        if(contenttype === "address_locales") {
            addressid = addressSelected.id;
        } else if(contenttype === "Documents") {
            streamid = document.getElementById('docselect').value;
        }else {
            contentid = document.getElementById('contentselect').value;
        }
        if(isBen){
            var def = getInfo("DefaultServiceProvider")
            CreatePrimaryToken(def, addressid , individual.id, contentid, streamid).then((resp) => {
                CreateSecondaryToken(def, id ,resp.token).then(()=> {
                    setShowAlert(true);
                    setAlertText("Contact shared with Beneficiary");
                    setSent(true);
                 
                }).catch(e=>{
                    console.error("Error contacting Beneficiary", e);
                    setAlertText("Error contacting Beneficiary, please try again!");
                    setShowAlert(true)
                })
                }).catch((err) => {
                console.error("Error contacting Beneficiary", err);
                setAlertText("Error contacting Beneficiary, please try again!");
                setShowAlert(true)
            })
        } else {
        CreatePrimaryToken(id,addressid , individual.id, contentid, streamid).then(() => {
            setShowAlert(true);
            setAlertText("Contact shared with Service Provider");
            setSent(true);
        }).catch((err) => {
            console.error("Error contacting Service Provider", err);
            setAlertText("Error contacting Service Provider, please try again!");
            setShowAlert(true)
        })
        }
    }

    const cancelFn = () => {
        if(previousPage) {
            navigate(previousPage,{ state: { readOnly:true}})
        } else {
            navigate(`/search/?text=${text}`)
        }
    }

    const handleInputChange = (e) => {
        const { value } = e.target;
        if(contenttype === "address_locales") {
        setAddressSelected(addrList[value]);
        } else if(contenttype === "Documents") {
            setSelectedDocId(value);
        }else {
            setSelectedContentId(value);
        }
        setSent(false);
    };

    const updateContentType = (e) => {
        const val = e.target.value;
        const selected = templates.find(ele =>  val === ele.Name);
        const processedTemplate = ProcessTemplate(selected);
        setContenttype(val);
        if(val === "address_locales") {
            setSent(Object.keys(addrList).length === 0)
            setAddressSelected(addrList[Object.keys(addrList)[0]])
        } else if(val === "Documents") {
            setSent(documents.length === 0)
        } else {
            setSent(!(securedContents.length > 0 &&  securedContents.filter(a => a.tags[processedTemplate.contentTypeTag]?.Value === val).length > 0))
        }
        setSelectedTemplate(selected);
    }

    return <div style={{ marginTop: "20px", marginLeft: "20px" }}>
        <div className="mx-auto max-w-screen-lg form-container p-5">
            <div>
                <h1 className="form-label py-2">
                    <AiOutlineImport className="inline-icon" />
                    {isBen ? "Connect with Beneficiary" : "Connect with Service Provider" }
                </h1>
            </div>

            <div className="grid grid-cols-1">

                <form className="" id="address select">
                    <label className="form-label" htmlFor="addressselect">
                        What would you like to share? 
                    </label>
                    <select id="contenttypeselect" onChange={updateContentType} className="col-span-12 form-input px-2 py-2">
                    <option key="" value="">Choose Content type</option>
                    { templates.map((element, index) => {
                    return <option key={element.Name} value={element.Name} selected={contenttype === element.Name} >{element?.Tags?.DisplayName?.Value || element.Name}</option> 
                    }) 
                    }</select>
            { contenttype === "address_locales" ? <><label className="form-label" htmlFor="addressselect">
                        Choose Address
                    </label>
                    {
                        Object.keys(addrList).length === 0 ?
                            <><p className="py-3">You don't have any address(es) yet.
                                <Link className="" to={{ pathname: "/AddAddressDetails" }} state={{ addresses: individual.addresses, previousPage: (isBen ? "/contactBeneficiary/" + id : "/contactServiceProvider/" + id) ,searchedText:text, isBen: isBen }} >
                                    <button className="text-blue-500 bg-slate-333 hover:bg-555 hover:underline " title="Add New Address">
                                        <AiOutlineProfile className="inline-icon" /> Add New Address
                                    </button>
                                </Link>  </p></>
                            : <select defaultValue={`${addressSelected?.id || Object.keys(addrList)[0]}`} onChange={handleInputChange} className="form-input" name="addressselect" id="addressselect">
                                {Object.keys(addrList || {}).map((addressId, index) => {
                                    const address = addrList[addressId];
                                    return (<option key={`${address.id}`} value={`${address.id}`}>{`${address.tags?.atag?.Name}`}</option>);
                                })}
                            </select>
                    } </> 
                    : contenttype === "Documents" ?  <><label className="form-label" htmlFor="docselect">
                            Choose Document
                        </label>
                        { documents.length > 0 ? <select id="docselect" defaultValue={`${selectedDocId}`} onChange={handleInputChange} className="form-input" >
                            { documents.sort((a, b) => { return a.tags?.Name?.Value?.toLowerCase().localeCompare(b.tags?.Name?.Value?.toLowerCase()) }).map((doc, index) => {
                               return <option key={doc.ID} value={doc.ID} selected={index === 0}>{doc.tags?.Name?.Value}</option> }) 
                            } 
                         </select> 
                            
                        : <><p className="py-3">You don't have any document(s) yet.
                            <Link className="" to={{ pathname: "/documentdetails" }} state={{ previousPage: (isBen ? "/contactBeneficiary" + id : "/contactServiceProvider/" + id) ,searchedText:text, isBen: isBen }} >
                                <button className="text-blue-500 bg-slate-333 hover:bg-555 hover:underline " title="Add New Document">
                                    <AiOutlineProfile className="inline-icon" /> Add New Document
                                </button>
                            </Link>  </p></>
                            
                        }</>
                    : contenttype === "" ? <></> 
                    : securedContents.length > 0 &&  securedContents.filter(a => a.tags[ProcessTemplate(selectedTemplate)?.contentTypeTag]?.Value === contenttype).length > 0 ? 
                        <select id="contentselect" defaultValue={`${selectedContentId}`} onChange={handleInputChange} className="form-input" >
                         { securedContents.filter(a => a.tags[ProcessTemplate(selectedTemplate)?.contentTypeTag]?.Value === contenttype).sort((a, b) => { return a.tags?.name?.Value?.toLowerCase().localeCompare(b.tags?.name?.Value?.toLowerCase()) }).map((sc, index) => {
                            return <option key={sc.id} value={sc.id} selected={index === 0}>{selectedTemplate ? sc.tags[ProcessTemplate(selectedTemplate).contentNameTag]?.Value : sc.tags?.name?.Value}</option> }) 
                         } 
                      </select> 
                    : <><p className="py-2">You don't have any {templates.map((ele) => { if(contenttype === ele.Name) return ele?.Tags?.DisplayName?.Value || ele.Name} )} yet.</p>
                                <Link className="" to={{ pathname: "/addsecurecontent/" }} state={{ contenttype: contenttype, template: selectedTemplate , previousPage: (isBen ? "/contactBeneficiary/" + id : "/contactServiceProvider/" + id),searchedText:text }} >
                                    <button className="text-blue-500 bg-slate-333 hover:bg-555 hover:underline " title="Add New">
                                        <AiOutlineProfile className="inline-icon" /> Add New {templates.map((ele) => { if(contenttype === ele.Name) return ele?.Tags?.DisplayName?.Value || ele.Name} )}
                                    </button>
                                </Link></>
                }
                </form>

                {/* {renderField("Message", "msg", "textarea",  messageVal , setMessageVal)} */}
                <div class="flex justify-center items-center space-x-4 py-2 ">
                    <button onClick={connect} style={{display:  sent   ? "none" : "block"}} type="submit" className="button-style positive-action">
                        Connect
                    </button>
                    {!sent ? (
                        <button onClick={cancelFn} className="button-style">Cancel</button>
                    ) : (
                        <button onClick={cancelFn} className="button-style">Close</button>
                    )}
                    <div
                        class=" col-span-10 bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative w-full"
                        role="alert"
                        style={{ display: showAlert ? "block" : "none" }}
                    >
                                        <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={()=> {setShowAlert(false)}}>X</button><span class="text-sm">{alertText} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
}